// 欺诈调查
var AssistAntiFraudCaseStay = function () { return import('~/pages/assist-manage/assist-anti-fraud-case-stay.vue'); };
var AssistAntiFraudSurveyCase = function () { return import('~/pages/assist-manage/assist-anti-fraud-survey-case.vue'); };
export default [
    {
        path: '/assist-fraud/assist-anti-fraud-case-stay',
        name: 'assist-anti-fraud-case-stay',
        component: AssistAntiFraudCaseStay //待分配案件
    },
    {
        path: '/assist-fraud/assist-anti-fraud-survey-case',
        name: 'assist-anti-fraud-survey-case',
        component: AssistAntiFraudSurveyCase // 欺诈调查
    }
];
